<div class="border">
  <div class="row">
    <div class="col-sm-6">
      <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormContenedor">
        <mat-label>TipoContenedor</mat-label>
        <mat-select name="TipoContenedor" formControlName="TipoContenedor">
          <mat-option *ngFor="let cat of catalogo" [value]="cat?.id">
            {{cat?.attributes?.clave}} - {{cat.attributes?.tipo}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="(FormContenedor.get('TipoContenedor').invalid && FormContenedor.get('TipoContenedor').touched)">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-3">
      <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormContenedor">
        <mat-label>MatriculaContenedor</mat-label>
        <input maxlength="50" formControlName="MatriculaContenedor" matInput>
        <mat-error
          *ngIf="(FormContenedor.get('MatriculaContenedor').invalid && FormContenedor.get('MatriculaContenedor').touched)">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-3">
      <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormContenedor">
        <mat-label>NumPrecinto</mat-label>
        <input maxlength="50" formControlName="NumPrecinto" matInput>
      </mat-form-field>
    </div>
  </div>
  <!-- <div class="col-12">
    <div class="flex align-items-center justify-content-center box">
      {{this.FormContenedor.value | json}}
    </div>
  </div> -->
</div>